import { Form } from 'informed';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import InputInformed from '../../InputInformed';
import ListFilterButton from '../buttons/ListFilterButton';
import { Collapse } from '../Collapse';
import ListFilterBox from './ListFilterBox';

const ListFilter = ({
  children,
  onValueChange,
  numberOfColumns,
  startOpen,
  hasSearchInput,
  className,
  initialValues,
  searchInputLabel,
  searchInputPlaceholder,
}) => {
  const [isCollapseOpen, setCollapse] = useState(startOpen);

  return (
    <Form
      onValueChange={onValueChange}
      className={className}
      initialValues={initialValues}
    >
      <div
        className={`d-flex align-items-flex-end ${
          !hasSearchInput ? 'justify-flex-end' : ''
        }`}
      >
        {hasSearchInput && (
          <InputInformed
            label={searchInputLabel}
            placeholder={searchInputPlaceholder}
            field="search"
            id="search"
            className="w-100 mr-2"
          />
        )}
        {children && (
          <ListFilterButton
            isCollapseOpen={isCollapseOpen}
            onClick={() => setCollapse(!isCollapseOpen)}
          />
        )}
      </div>
      <Collapse className="mt-1 mb-2" isCollapseOpen={isCollapseOpen}>
        <ListFilterBox
          className={`form-grid-${numberOfColumns} mt-1 mb-3 align-items-center`}
        >
          {children}
        </ListFilterBox>
      </Collapse>
    </Form>
  );
};

ListFilter.propTypes = {
  children: PropTypes.node,
  numberOfColumns: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  startOpen: PropTypes.bool,
  hasSearchInput: PropTypes.bool,
  className: PropTypes.string,
  initialValues: PropTypes.object,
  searchInputLabel: PropTypes.string,
  searchInputPlaceholder: PropTypes.string,
};

ListFilter.defaultProps = {
  children: null,
  numberOfColumns: '3',
  startOpen: false,
  hasSearchInput: true,
  className: '',
  initialValues: {},
  searchInputLabel: 'Buscar',
  searchInputPlaceholder: '',
};

export default ListFilter;
